// eslint-
// declare all characters

import { TFunction } from "i18next";
import { FieldValues, UseFormSetError } from "react-hook-form";
import { FormErrorObject } from "./types";

export const generateString = (length: number) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
};

export const setMultipleFormErrors = (
    errors: FormErrorObject,
    setError: UseFormSetError<FieldValues>,
    t?: TFunction
) => {
    if (errors && Object.entries(errors).length > 0) {
        Object.entries(errors).forEach(([key, value]) => {
            setError(key, {
                type: "custom",
                message: t ? t("shared.validation.api." + value) : value,
            });
        });
    }
};

export interface FilterQueryParams {
    [key: string]: string | string[];
}

export function parseQueryParams(query: string, excludedParams?: string[]): FilterQueryParams {
    const params: FilterQueryParams = {};
    let queries = query.split("&");
    if (query.indexOf("?") === 0) {
        queries = query.substring(1).split("&");
    }

    for (let i = 0; i < queries.length; i++) {
        const pair = queries[i].split("=");
        const key = decodeURIComponent(pair[0]);
        const value = decodeURIComponent(pair[1]);

        if (!excludedParams?.includes(key)) {
            if (key in params) {
                const currentValue = params[key];
                if (typeof currentValue === "string") {
                    params[key] = [currentValue, value];
                } else {
                    currentValue.push(value);
                }
            } else {
                params[key] = value;
            }
        }
    }

    return params;
}

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{8,}$/;

export const debounce = (func: any, wait: any) => {
    let timeout: any;

    return function executedFunction(...args: any) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

export const capitalize = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const PAGINATION_OPTIONS = [10, 25, 50];
